import React, {useEffect, useState, useCallback, useRef} from 'react';
import Form from '../../Pages/Form'
import {Gallery} from "../DisplayRendering/Gallery";
import {v4 as uuid} from 'uuid';
import {SelectButton} from "primereact/selectbutton";
import {Button} from "primereact/button";
import _ from 'lodash';
import {useField, useFormikContext} from "formik";
import {getItemNames, insertRecordFormData, isEditingRecord, pluckFirst, wrapArray} from "../utils";
import {useIsOpenControls} from "../../hooks";
import {ConfirmPopup, confirmPopup} from 'primereact/confirmpopup';
import {controlsVisible, orderRecords, renderControlButtons} from "./common";
import RecordSearch from "../RecordSearch";
import searchElements from "../AirtableFields/RecordLinks/search.common";
import {Navigator} from "../DisplayRendering/Navigator";
import {Dialog} from "primereact/dialog";
import {Divider} from "primereact/divider";
import {resetFormData} from "../../@redux/formData/actions";
import {useDispatch} from "react-redux";

type SubFormProps = {
    form_id: number;
    name: string
    visible: OpenControls
    display_as: string
    mode: string
    dialog?: boolean
    value: any[]
    initId?: string
    getRecord?: (id:string|any, records?:any[]) => any
    details: any
    extraConfig: any
    controls: {lookup:OpenControls,create:OpenControls,remove:OpenControls,order:OpenControls}
    recordSearch: (processSelected: (selected:any[]) => void, options:any)  => any
    onClose: (dirtyRecs) => void
    count?:number

    primaryField?: any
}
export const SubForm = ({form_id, name, mode = 'manage', initId = "", visible, primaryField, controls, display_as, value, getRecord, dialog = false, details, recordSearch, extraConfig, onClose, count = 0}:SubFormProps) => {
    const [index, setIndex] = useState(0)
    const [dirtyRecs, setDirtyRecs] = useState({})
    const [field,meta,helpers] = useField(name)
    const [headerTitle, setHeaderTitle] = useState('')
    const d = useDispatch()
    const formRef = useRef(null)
    const formMode = isEditingRecord(details.record_id) ? 'edit' : 'create'
    console.log('**SubForm Start**', {index, initId, mode, display_as, value, details, extraConfig, navDisabled: extraConfig.disableNav})
    useEffect( () => {
        const idIndex = _.findIndex(value, {tableRecordId:initId})
        if(idIndex >=0)setIndex(idIndex)
        else if(index >= value.length)setIndex(value.length-1)
        else setIndex(0)
    }, [value.length,initId])



    const onDirty = useCallback( (recId) => {
        setDirtyRecs({...dirtyRecs, [recId]: true})
    }, [dirtyRecs])

    const closeEdit = useCallback(() => {
        visible.handleClose()
        console.log('SUB FORM DONE', dirtyRecs)
        onClose(dirtyRecs)
        setDirtyRecs({})
    }, [onClose, dirtyRecs,visible] )
    const closeCancel = useCallback(() => {
        visible.handleClose()
        //reset dirty forms
        for(let formId of Object.keys(dirtyRecs)){
            d(resetFormData(formId) as any)
        }
        setDirtyRecs({})
        onClose({})
    }, [onClose, dirtyRecs,visible] )

    const onRemove = useCallback( () => {
        const newOptions = [...value]
        newOptions.splice(index, 1)
        helpers.setValue(newOptions)
        setIndex(Math.max(0, index - 1))
    }, [value, helpers, index, setIndex])

    const onLookup = useCallback( () => {
        controls.lookup.handleOpen()
    }, [controls.lookup])

    const onCreate =  useCallback ( () => {
        helpers.setValue( wrapArray(value).concat({tableRecordId: uuid()}))
        setIndex(value.length)
    }, [helpers, value, setIndex])

    const onOrder = useCallback(() => {
        controls.order.handleOpen()
    }, [controls.order])

    const onEdit = useCallback( () => {

    }, [])

    const onDisplay = useCallback( () => {

    }, [])

    const onSearch = useCallback( (selected:any[]) => {
        helpers.setValue(wrapArray(selected))
        controls.lookup.handleClose()
    }, [value, helpers,  controls.lookup])

    const checkIndex = useCallback ( (nextIndex = -1, onAfter = null) => {
        if(formRef.current){
            formRef.current?.validateForm().then( errors => {
                if(_.isEmpty(errors)){
                    if(nextIndex >= 0){
                        setIndex(nextIndex)
                    }
                    if(onAfter)onAfter()
                }else{
                    formRef.current?.setTouched(_.reduce( errors, (out, val,key) => { out[key] = true; return out;}, {}))
                }
            })
        }
    }, [formRef.current,setIndex])
    const checkAndClose = useCallback( () => {
        checkIndex(-1, closeEdit)
    }, [closeEdit])

    const getRecordTitleKey = useCallback((config:any) => {
        if(config.disableTitle)return ''
        return config.titleField || primaryField

    }, [primaryField])
    const pkKey = getRecordTitleKey(extraConfig)
    const setRecordTitle = useCallback((record:any) => {
        const nameKey = '{{RECORD_NAME}}'
        const keys = []
        if(_.isObject(pkKey as any)) {
            keys.push(pkKey.title)
            keys.push(pkKey.name)
        }
        let recTitleVal = pluckFirst(record,keys)
        if(_.isObject(recTitleVal as any)){
            recTitleVal = pluckFirst(recTitleVal,['name','value','email','url','error'])
        }
        const newTitle = (extraConfig.dialogHeader || nameKey).replace(nameKey,  recTitleVal)
        console.log('Setting RECORD TITLE', {pkKey,header: extraConfig.dialogHeader,record,nameKey,recTitleVal,newTitle})
        if(newTitle !== headerTitle)setHeaderTitle( newTitle )
        return newTitle

    },[pkKey,extraConfig,headerTitle,setHeaderTitle])


    const useConfig = {showItemNavigators: false,showThumbnails: false, showIndicators: true, ...extraConfig}
    const renderSubform = () => {

            if(!form_id)return ( <p>Form Not Configured Yet</p> )

            if (['navigator', 'gallery'].includes(display_as)) {
                const header = () => {
                    return <></>
                }
                const itemRender = (item) => {
                    const record = getRecord(item, value)
                    const recId = record?.tableRecordId
                    setRecordTitle(record)
                    // const recTitle = getRecordTitle(record,extraConfig)
                    console.log('SubForm Item Render', {record, item, value, headerTitle})
                    return (
                        <div style={{width: '100%', paddingTop: '5px', height: dialog ? '100%' : '600px'}}>
                            {['manage'].includes(mode) && renderControlButtons({
                                lookup: true,
                                create: true,
                                edit: false,
                                display: false,
                                order: true,
                                remove: true
                            }, {onLookup, onCreate, onEdit, onDisplay, onOrder, onRemove}, _.get(extraConfig,'controls',{}))}
                            <div style={{width: '100%'}}>
                                {/*{recTitle && <div style={{float: 'left'}}><h1>{recTitle}</h1></div>}*/}
                                {value.length > 1 && !extraConfig.disableNav && <div style={{float: 'right'}}>
                                    <SelectButton value={null} options={[
                                        {label: 'PREV', value: -1, disabled: index <= 0},
                                        {label: `${index + 1}/${value.length}`, value: 0, disabled: true},
                                        {label: 'NEXT', value: 1, disabled: index >= value.length - 1},
                                    ]} onChange={(e) => checkIndex(index + Number(e.value))}/>

                                </div>}
                            </div>
                            <Divider />
                            <div style={{width: '100%', height: dialog ? undefined : '400px', overflow: 'auto'}}>
                                <div style={{paddingLeft: '5px', paddingRight: '15px'}}>
                                    <Form key={recId || 'create'} mode={details.mode}
                                          form_id={form_id}
                                          record_id={recId} onDirty={onDirty} formRef={formRef} path={details.path} count={count}/>
                                </div>
                            </div>
                        </div>
                    )

                }
                const thumbnailRender = (item) => {
                    const record = getRecord(item,value)
                    const recId = record.tableRecordId

                    return (
                        <p style={{color: 'white'}}>{record['Name']}</p>
                    )
                }
                const inner = () => {
                    if(value.length > 1) {
                        if (display_as === 'gallery') {
                            return <Gallery env={'form'} value={value} header={header()} activeIndex={index}
                                            onItemChange={i => checkIndex(i)}
                                            extraConfig={useConfig} render={itemRender} thumbnail={thumbnailRender}/>
                        } else if (display_as === 'navigator') {
                            return <Navigator render={itemRender} extraConfig={useConfig} value={value}
                                              showIndex={index}
                                              onPage={(first) => checkIndex(first)}/>
                        }
                    }
                    return <>{itemRender(value[index])}</>
                }
                const {plural} = getItemNames(extraConfig,'Linked Record')
                return <>
                    {value.length ? (<>
                        {inner()}
                        <ConfirmPopup/>
                    </>) : (
                        <>
                            <h3>No {plural}</h3>
                            {['manage'].includes(mode) && renderControlButtons(controlsVisible({lookup: true, create: true}, extraConfig, formMode), {onLookup, onCreate},_.get(extraConfig,'controls',{}))}
                        </>
                    )}
                    {orderRecords(value, controls.order, extraConfig, (newItems) => helpers.setValue(newItems))}
                    {recordSearch(onSearch, {hideInitSelected: true})}
                </>


            }
        return <p>Sub Form</p>
    }
    //const inner = visible.isVisible ? renderSubform() : <></>
    const inner = renderSubform()
    if(dialog){
        return (
            <Dialog breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '50vw', height: '85vh'}} onHide={closeCancel} visible={visible.isVisible} closable={true} draggable={false}
                    footer={(
                        <>
                        <Button onClick={closeCancel} label={'Cancel'} className={'p-button-outlined'}/>
                        <Button onClick={checkAndClose} label={'SAVE'}/>
                        </>
                    )} header={headerTitle || ''}
            >{inner}</Dialog>
        )
    }
    return inner

}

export default SubForm
